import { Navigate } from "react-router-dom";
import { StaffuseAuth } from "./StaffuseAuth";

export const StaffProtectedRoute = ({ children }) => {
  const { user } = StaffuseAuth();
  if (!user) {
    // user is not authenticated
    return <Navigate to="/Staff/login" />;
  }
  return children;
};
